// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__33LcP","label":"Category_label__3IFEO","content":"Category_content__33Gkf","header":"Category_header__3w8YT","location":"Category_location__34BME"};